module.exports = __webpack_public_path__ + "img/viewvideo.2118d0f0.svg";